import { subscribe } from 'communicator/store';
import { sendToVisaSdk } from 'communicator/utils/visa-sdk';
import { getAccessToken, getIsVisaSRCi } from './selectors';

if (getIsVisaSRCi()) {
  // Whenever accessToken is updated, notify the Visa SRCi so it can restart its
  // session timers.
  subscribe(getAccessToken, accessToken => {
    if (typeof accessToken?.expiresIn === 'number') {
      sendToVisaSdk('visa-communicator:internal:token-update', {
        expiresIn: accessToken.expiresIn
      });
    }
  });
}
